import MaintenancePage from "../../components/feature/MaintenancePage";
import SEOHead from "../../components/feature/SEOHead";

const LOGO =
  "https://storage.readdy-site.link/project_files/9ee712e0-c50a-4d2b-9956-d4b4346de3f4/065c2496-05cb-41dd-b2a8-4344a5437f24_rec_logo.png?v=04eb77b63b1a7bd9723821a48b064ad3";

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "https://example.com";

const schema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/rec99au#website`,
  name: "REC99AU",
  url: `${siteUrl}/rec99au`,
  inLanguage: "en-AU",
  description:
    "REC99AU is currently undergoing scheduled maintenance. We'll be back shortly with an improved online gaming experience.",
  potentialAction: {
    "@type": "SearchAction",
    target: `${siteUrl}/rec99au?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export default function Rec99au() {
  return (
    <>
      <SEOHead
        title="REC99AU | We'll Be Back Shortly — Maintenance Mode"
        description="REC99AU is currently undergoing scheduled maintenance. We're working hard to improve your experience. Check back soon!"
        keywords="REC99AU, REC99, online gaming, maintenance"
        canonicalPath="/rec99au"
        schemaJson={schema}
        ogImage={LOGO}
        ogImageAlt="REC99AU Logo"
        siteName="REC99AU"
      />
      <MaintenancePage
        logoSrc={LOGO}
        logoAlt="REC99AU Logo"
        accentColor="#5BC8F5"
        glowRgb="91,200,245"
        bgFrom="#001525"
        whatsappLink="https://wa.me/61414502843"
        telegramLink="https://t.me/Rec99aucs2"
      />
    </>
  );
}
